module.exports = __webpack_public_path__ + "media/das-ist-das-hauptmenue.4c788df8.mp3";